import React from 'react'
import { Link } from 'gatsby'

const ServiceSidebar = () => {
  return (
    <div className="services-details-info">
      <ul className="services-list">
        <li>
          <Link to="#" onClick={(e) => e.preventDefault()} className="active">
            AI & ML Development
          </Link>
        </li>
        <li>
          <Link to="#" onClick={(e) => e.preventDefault()}>
            Data Analytics
          </Link>
        </li>
        <li>
          <Link to="#" onClick={(e) => e.preventDefault()}>
            Data Science
          </Link>
        </li>
        <li>
          <Link to="#" onClick={(e) => e.preventDefault()}>
            Artificial Intelligence
          </Link>
        </li>
        <li>
          <Link to="#" onClick={(e) => e.preventDefault()}>
            Data Visualization
          </Link>
        </li>
      </ul>

      <div className="download-file">
        <h3>Brochures</h3>

        <ul>
          <li>
            <Link to="#" onClick={(e) => e.preventDefault()}>
              PDF Download <i className="bx bxs-file-pdf"></i>
            </Link>
          </li>
          <li>
            <Link to="#" onClick={(e) => e.preventDefault()}>
              Services Details.txt <i className="bx bxs-file-txt"></i>
            </Link>
          </li>
        </ul>
      </div>

      <div className="services-contact-info">
        <h3>Contact Info</h3>

        <ul>
          <li>
            <div className="icon">
              <i className="bx bx-user-pin"></i>
            </div>
            <span>Phone:</span>
            <a href="tel:0917656679">091 765 6679</a>
          </li>
          <li>
            <div className="icon">
              <i className="bx bx-map"></i>
            </div>
            <span>Location:</span>
            Nonthaburi, Thailand
          </li>
          <li>
            <div className="icon">
              <i className="bx bx-envelope"></i>
            </div>
            <span>Email:</span>
            <a href="mailto:info@websitecafe.info">info@websitecafe.info</a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default ServiceSidebar
